import { render, staticRenderFns } from "./StocksDebitsTab.vue?vue&type=template&id=7a64d359&scoped=true&"
import script from "./StocksDebitsTab.vue?vue&type=script&lang=js&"
export * from "./StocksDebitsTab.vue?vue&type=script&lang=js&"
import style0 from "./StocksDebitsTab.vue?vue&type=style&index=0&id=7a64d359&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a64d359",
  null
  
)

export default component.exports
import {QTr,QTh,QTd,QIcon,QTooltip,QBtnDropdown,QTable,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QTr,QTh,QTd,QIcon,QTooltip,QBtnDropdown,QTable,QInnerLoading,QSpinnerGears}, component.options.components || {})
